<template>
  <ValidationObserver tag="form" :ref="`${_uid}-observer`" :data-vv-scope="vvScope">
    <div :key="`${index}`" v-for="(field, index) in scaffoldingData.items" class="q-mb-xs">
      <template v-if="field.fieldName == '{this.root}'">
        <component :ref="`${_uid}${field.fieldName ? field.fieldName : ''}${index}`" :is="field.type"
          v-on="{...$listeners, 'command': command}" :config="field" v-model="modelProps"
          :root-model="rootModel ? rootModel : modelProps" :parent="_self" :key="field.inputKey"
          :origin-model="originModel ? originModel : undefined"></component>
      </template>
      <template v-else>
        <component :ref="`${_uid}${field.fieldName ? field.fieldName : ''}${index}`" :is="field.type"
          v-on="{...$listeners, 'command': command}" :config="field" v-model="modelProps[field.fieldName]"
          :root-model="rootModel ? rootModel : modelProps" :parent="_self" :key="field.inputKey"
          :origin-model="originModel ? originModel[field.fieldName] : undefined">
        </component>
      </template>
    </div>
  </ValidationObserver>
</template>
<script>
import ValidateGlobal from './inputs/ValidateGlobal.js'
export default {
  mixins: [ValidateGlobal],
  props: {
    scaffolding: [String, Object],
    modelProps: Object,
    rootModel: Object,
    parent: Object,
    originModel: Object
  },
  data () {
    return {
      scaffoldingData: this.R.clone(this.scaffolding),
      emptyState: [],
      value: this.modelProps,
      valueNotWatch: false,
      vvScope: this.scaffolding && this.scaffolding.vvScope ? this.scaffolding.vvScope : `${this._uid}-observer`
    }
  },
  model: {
    prop: 'modelProps',
    event: 'inputRoot'
  },
  async created () {
    let vm = this
    if (typeof this.scaffolding === 'string') {
      this.scaffoldingData = await this.$query(['Scaffolding', this.scaffolding]).then(res => {
        vm.$q.loading.hide()
        return res
      })
    }
    if (this.scaffolding && !this.scaffolding.hasOwnProperty('items')) {
      this.scaffoldingData.items = {}
      for (let key in this.scaffolding) {
        this.scaffoldingData.items[key] = this.scaffolding[key]
      }
    }
    // Add vee validate scope
    this.addVVScope()
    this.emptyState = this.scaffoldingData ? this.R.times(() => true, Object.keys(this.scaffoldingData.items).length) : []
  },
  methods: {
    async validate () {
      let vm = this
      Object.keys(vm.scaffoldingData.items).forEach(element => {
        try {
          let obj = vm.scaffoldingData.items[element]
          vm.$refs[`${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate()
        } catch (error) {
          console.log(error)
        }
      })
      await vm.$refs[`${vm._uid}-observer`].validate()
      let errInScope = vm.errors.items.filter(item => item.scope === vm.vvScope)
      return vm.R.isEmpty(errInScope)
    },
    command (payload) {
      let vm = this
      switch (payload.cmd) {
        case 'submit-data':
          vm.$emit('submit-data')
          break
        case 'empty-data':
          this.checkEmptyData(payload.config)
          break
        case 'fetch-data':
          this.$emit('fetch-data')
          break
        default:
          break
      }
    },
    checkEmptyData (config) {
      if (config && this.scaffoldingData) {
        let finded = this._.findKey(this.scaffoldingData.items, config)
        if (finded) {
          this.emptyState[finded[finded.length - 1] - 1] = this._.isEmpty(this.value[config.fieldName])
        }
      }
      if (this._.every(this.emptyState)) {
        this.$emit('all-fields-empty', this.scaffoldingData)
      }
    },
    addVVScope () {
      if (this.scaffoldingData) {
        for (let key in this.scaffoldingData.items) {
          this.scaffoldingData.items[key].vvScope = this.vvScope
        }
      }
    }
  },
  watch: {
    scaffolding: {
      handler: function () {
        this.scaffoldingData = this.R.clone(this.scaffolding)
        if (this.scaffolding && !this.scaffolding.hasOwnProperty('items')) {
          this.scaffoldingData.items = {}
          for (let key in this.scaffolding) {
            this.scaffoldingData.items[key] = this.scaffolding[key]
          }
        }
        this.addVVScope()
      },
      deep: true
    }
  }
}
</script>
